export const createVstTemplateBaseline = (project = {}, samples = project.samples || []) => ({
  templateId: project.pricingTemplateId || project.pricing_template_id || project.projectTemplate || project.project_template || "",
  interfaceControls: (project.interfaceControls || project.interface_controls || []).map((control) => ({
    id: String(control.id || ""),
    kind: String(control.kind || "component"),
    variant: String(control.component_variant || "classic"),
  })),
  engineModules: (project.engineModules || project.engine_modules || []).map((module) => ({
    id: String(module.id || ""),
    type: String(module.type || "").toLowerCase(),
  })),
  samples: (samples || []).map((sample) => ({ id: String(sample.id || sample.sample_id || "") })),
  effects: {},
  backgroundImageUrl: project.backgroundImageUrl || project.background_image_url || "",
});
